/**
 *	shop-info.directive.js
 */

import shopInfoTpl from './shop-info.tpl.html!text';
import ShopInfoCtrl from './shop-info.ctrl.js';

var shopInfoDirective = function() {
 	return {
 		restrict: 'E',
 		replace: true,
 		transclude: true,
 		template: shopInfoTpl,
 		scope: {},
 		controller: ShopInfoCtrl,
 		controllerAs: 'ctrl',
 		bindToController: {
 			hasAppointment: '<',
 			shopName: '<',
 			shopDescription: '<',
 			todaysProgram: '<',
 			directionsUrl: '<',
			shopType: '<',
			shopSubType: '<',
            subTypeDescr: '<'
 		}
 	};
 };

 export default shopInfoDirective;